import { render, staticRenderFns } from "./WebsiteSchulenSubscriptionGrid.vue?vue&type=template&id=01265f30&scoped=true"
import script from "./WebsiteSchulenSubscriptionGrid.vue?vue&type=script&lang=js"
export * from "./WebsiteSchulenSubscriptionGrid.vue?vue&type=script&lang=js"
import style0 from "./WebsiteSchulenSubscriptionGrid.vue?vue&type=style&index=0&id=01265f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01265f30",
  null
  
)

export default component.exports